<template>
    <div class="text-xs-center">
    <v-chip 
        v-for="(item,item_index) in currentItems"
        :key="item_index"
        color="grey lighten" text-color="white">{{item}}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    currentItems: {
      type: Array,
      default: () => []
    }
  }
};
</script>
